import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';

function Industories() {
  const page = "industry";
  return (
    <div>
      {/* <Header /> */}
  <section className={`hero ${page}`}>
    <h1>Industries</h1>
  </section>

<section className="industory-section" id="industory">
  <div className="container">

    {/* Section 1: Heading */}
    {/* <div className="industory-heading">
      <div className="industory-kicker" aria-hidden="true">Industries We Serve</div>
    </div> */}

    {/* Section 2: Grid */}
    <div className="industory-grid">
      {/* Card 1 */}
      <a className="industory-card" href="/solutions/oil-gas">
        <div className="thumb">
          <img src="assets/images/industry/oil-gas.png" alt="Oil and Gas" />
        </div>
        <div className="description">
          Advanced drilling fluids and solutions for optimized exploration and production.
        </div>
        <div className="card-footer">
          <div className="title">Oil and Gas</div>
        </div>        
        {/* <div className="title">Oil and Gas</div> */}
      </a>

      {/* Card 2 */}
      <a className="industory-card" href="/solutions/water-well">
        <div className="thumb">
          <img src="assets/images/industry/water-well.png" alt="Water Well" />
        </div> 
        <div className="description">
          products for enhanced performance and longevity.
        </div>
        <div className="card-footer">
          <div className="title">Water Well</div>
        </div>
      </a>

      {/* Card 3 */}
      <a className="industory-card" href="/solutions/automotive">

        <div className="thumb">
          <img src="assets/images/industry/automotive.png" alt="Automotive" />
        </div> 
        <div className="description">
          High-performance materials for safety-critical components.
        </div>
        <div className="card-footer">
          <div className="title">Automotive</div>
        </div>
      </a>

      {/* Card 4 */}
      <a className="industory-card" href="/solutions/civil-sector">
        <div className="thumb">
          <img src="assets/images/industry/civil-sector.png" alt="Civil Sector" />
        </div>
        <div className="description">
          Solutions for soil testing, piling, tunneling, and waterproofing.
        </div>
        <div className="card-footer">
          <div className="title">Civil Sector</div>
        </div>
      </a>

      {/* Card 5 */}
      <a className="industory-card" href="/solutions/steel-industry">
        <div className="thumb">
          <img src="assets/images/industry/steel-industry.png" alt="Steel & Foundries" />
        </div>         
        <div className="description">
          High-temperature-resistant materials for foundries and steel production.
        </div>
        <div className="card-footer">
          <div className="title">Steel & Foundries</div>
        </div>
      </a>

    </div>

  </div>
</section>      
      {/* <Footer /> */}
    </div>
  )
}

export default Industories